import { Link } from 'react-router-dom';
import { categoryData } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 pt-16 md:pt-20 pb-8 px-4 md:px-6">
      <div className="mx-auto" style={{ maxWidth: 1200 }}>
        <div className="bg-background-50 rounded-2xl p-10 md:p-14 relative overflow-hidden">
          <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-foreground-950 rotate-6 rounded-xl opacity-5 hidden lg:block"></div>
          <div className="absolute -top-4 -right-4 w-16 h-16 bg-foreground-950 -rotate-3 rounded-xl opacity-5 hidden lg:block"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 relative z-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-table-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-foreground-950">GTBuy Hub</span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">
                GTBuy Spreadsheet Hub provides comparison-based informational content for shopping spreadsheet platforms. We are an independent directory that helps shoppers discover product categories and make informed decisions.
              </p>
            </div>

            <div>
              <h4 className="font-label text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">Categories</h4>
              <ul className="space-y-2">
                {categoryData.slice(0, 7).map((cat) => (
                  <li key={cat.seq}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-label text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">More Categories</h4>
              <ul className="space-y-2">
                {categoryData.slice(7).map((cat) => (
                  <li key={cat.seq}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-label text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">Resources</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/gtbuy-sheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">
                    GTBuy Sheet Guide
                  </Link>
                </li>
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">
                    Home
                  </Link>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">
                    Main Website
                  </a>
                </li>
              </ul>

              <h4 className="font-label text-xs font-semibold text-foreground-400 uppercase tracking-wider mt-6 mb-4">Legal</h4>
              <ul className="space-y-2">
                <li>
                  <span className="text-sm text-foreground-500">Safety Information</span>
                </li>
                <li>
                  <span className="text-sm text-foreground-500">Privacy Policy</span>
                </li>
                <li>
                  <span className="text-sm text-foreground-500">Terms of Use</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} GTBuy Spreadsheet Hub. All rights reserved.
              <span className="mx-2">|</span>
              <span>Independent directory · Not a seller</span>
            </p>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:text-foreground-950 hover:bg-background-200 transition-colors">
                <i className="ri-global-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:text-foreground-950 hover:bg-background-200 transition-colors">
                <i className="ri-external-link-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}